var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"observe",staticClass:"text-ayadi-900 text-center"},[_vm._v(_vm._s(_vm.showStatus ? _vm.$t("main.load_more") : ""))])
}
var staticRenderFns = []

export { render, staticRenderFns }